<pcs-overlay *ngIf="loading">
  <pcs-loader></pcs-loader>
</pcs-overlay>

<ng-content></ng-content>
